const isExternalLink = true

export const businessLinks = [
  {
    id: 'retail',
    anchorImgPath: '/images/business-retail-links.svg',
    title: '流通小売事業',
    engTitle: 'Distribution Retail',
    titleImgPath: '/images/business-retail.svg',
    businessContent: (
      <>
        <p>
         『あなたの「生活必需店」。』をコンセプトとしたディスカウントストアを運営しております。
        </p>
        <p>九州を地盤とした店舗ネットワークで、日本全国に展開しております。</p>
        <p>
          店舗フォーマットは、中型の「スーパーセンター」を中核としながら、小型から大型まで多岐に渡っております。
        </p>
        <p>
          商品ラインナップは、食品（特に生鮮食品）に注力しており、こだわりのおいしさを追求しております。非食品は生活用品やハード用品を取り扱っております。
        </p>
        <p>
          価格戦略は、EDLP（Every Day Low
          Price）を基本方針としており、競争力ある価格提案を行っております。
        </p>
      </>
    ),
    companies: [
      {
        link: 'https://trial-holdings.inc/',
        imgPath: '/images/OurBusiness_logo_TRIAL holdings.webp',
        name: '株式会社トライアルホールディングス（持株会社）',
        isExternalLink,
      },
      {
        link: 'https://www.trial-net.co.jp/',
        imgPath: '/images/cardlink-logo-traial.webp',
        name: '株式会社トライアルカンパニー',
        isExternalLink,
      },
      {
        imgPath: '/images/business_retail_dummy.svg',
        name: '株式会社トライアルストアーズ',
      },
      {
        imgPath: '/images/cardlink-logo-traial.webp',
        name: '株式会社青森トライアル',
      },
      {
        imgPath: '/images/Logo_TRIALGO_1L_1.png',
        name: '株式会社トライアルGO',
      },
      {
        imgPath: '/images/business_retail_dummy.svg',
        name: '株式会社魚寅',
      },
      {
        imgPath: '/images/business_retail_dummy.svg',
        name: '株式会社白鳥ロジスティックシステム',
      },
      {
        link: 'https://www.seiyu.co.jp/',
        imgPath: '/images/business_SEIYU.png',
        name: '株式会社西友',
        isExternalLink,
      },
      {
        imgPath: '/images/business_retail_dummy.svg',
        name: '株式会社西友プロキュアメント',
      },
      {
        imgPath: '/images/business_retail_dummy.svg',
        name: '株式会社西友サービス',
      },
      {
        link: 'https://meijiya-kohaku.co.jp/',
        imgPath: '/images/business_meijiya.png',
        name: '株式会社明治屋',
        isExternalLink,
      },
      {
        link: 'https://info-soukatei.com/',
        imgPath: '/images/business-lePetitNicois.webp',
        name: '株式会社Le Petit Nicois',
        isExternalLink,
      },
      {
        link: 'https://www.trial-net.co.jp/foodpark/shingu/',
        imgPath: '/images/business_retail_dummy.svg',
        name: '株式会社トライアルフードパーク',
        isExternalLink,
      },
      {
        link: 'https://www.tls-net.co.jp/',
        imgPath: '/images/business-tls.webp',
        name: '株式会社MLS',
        isExternalLink,
      },
      {
        link: 'https://su-pay.jp/',
        imgPath: '/images/OurBusiness_logo_SU-PAY.webp',
        name: '株式会社SU-PAY',
        isExternalLink,
      },
      {
        link: 'https://autopit.co.jp/',
        imgPath: '/images/business_trial_cars.svg',
        name: '株式会社トライアルカーズ',
        isExternalLink,
      },
      {
        imgPath: '/images/business_retail_dummy.svg',
        name: '株式会社トライアル・インシュアランス・サービス',
      },

      {
        imgPath: '/images/business_retail_dummy.svg',
        name: 'TRIAL.Korea Co.,Ltd.（関連会社）',
      },
      {
        imgPath: '/images/business_retail_dummy.svg',
        name: 'F&G Retail Co.,Ltd.（関連会社）',
      },
    ],
  },
  {
    id: 'retail-ai',
    anchorImgPath: '/images/business-retail-ai-links.svg',
    title: 'リテールAI事業',
    engTitle: 'Retail AI',
    titleImgPath: '/images/business-retail-ai.svg',
    businessContent: (
      <p>
        「テクノロジーによって、新時代のお買い物体験を生み出し、流通の仕組みを革新する」をビジョンとして、IoTデバイスを活用した各種ソリューションやソフトウェアサービスを提供しております。
        <br />
        Skip Cart等の開発を通じて、お客様に新しい買い物体験を提供するとともに、CPG（消費財）メーカーとの協働やデータの活用によって流通業界に多く存在している「ムダ・ムラ・ムリ」の削減を目指しています。
      </p>
    ),
    companies: [
      {
        link: 'https://www.retail-ai.jp/',
        imgPath: '/images/cardlink-logo-retail-ai.svg',
        name: '株式会社Retail AI',
        isExternalLink,
      },
      {
        path: 'http://www.trechina.com/',
        imgPath: '/images/business_retail_ai_dummy.svg',
        name: '拓锐安（上海）科技有限公司',
        isExternalLink,
      },
      {
        path: 'http://www.trechina.com/',
        imgPath: '/images/business_tre_china.png',
        name: '烟台创迹软件有限公司',
        isExternalLink,
      },
      {
        path: 'http://www.trechina.com/',
        imgPath: '/images/business_retail_ai_dummy.svg',
        name: '上海翔迹企业管理有限公司',
        isExternalLink,
      },
      {
        link: 'https://salesplus.co.jp/',
        imgPath: '/images/sales-plus-logo.webp',
        name: '株式会社SalesPlus（関連会社）',
        isExternalLink,
      },
      {
        link: 'https://www.retail-cix.jp/',
        imgPath: '/images/Logo_Retail-CIX.png',
        name: '株式会社RetailｰCIX（関連会社）',
        isExternalLink,
      },
    ],
  },
  {
    id: 'others',
    anchorImgPath: '/images/business-other-links.svg',
    title: 'その他',
    engTitle: 'Other Business',
    titleImgPath: '/images/business-other.svg',
    businessContent: (
      <p>
        不動産の所有・活用及び旅館業や、こだわりの料理を提供する料亭などの飲食業、ゴルフ場運営などのリゾート関連事業を行っております。
      </p>
    ),
    companies: [
      {
        link: 'https://sunrealestate.jp/company/',
        imgPath: '/images/business_others_dummy.svg',
        name: '株式会社トライアルリアルエステート',
        isExternalLink,
      },
      {
        link: 'http://ted.trial-net.co.jp/',
        imgPath: '/images/business_others_dummy.svg',
        name: '株式会社トライアル開発',
        isExternalLink,
      },
      {
        link: 'https://www.kawamurasatodesign.com/',
        imgPath: '/images/business-kawamura.webp',
        name: '株式会社河村佐藤デザイン',
        isExternalLink,
      },
      {
        imgPath: '/images/business_others_dummy.svg',
        name: '株式会社トライアルゴルフ&リゾート',
      },
      {
        imgPath: '/images/business_others_dummy.svg',
        name: '株式会社ティージーアール阿蘇',
      },
      {
        imgPath: '/images/business_others_dummy.svg',
        name: '株式会社ティージーアール大分',
      },
      {
        imgPath: '/images/business_others_dummy.svg',
        name: '株式会社トライアルベネフィット',
      },
      {
        imgPath: '/images/business_others_dummy.svg',
        name: '株式会社トライアルチャレンジド',
      },
      {
        imgPath: '/images/business_others_dummy.svg',
        name: '株式会社Fieldman',
      },
    ],
  },
]
